(ns hai.ui.components.new-design.utils)

(def base-font-size 16.0)

(def ui-scale
  ;; 0.75
  1
  )

(defn px->rem
  [px]
  (let [rem (/ px base-font-size)]
    (str (* rem ui-scale) "rem")))

(defn px*
  [px]
  (* px ui-scale))
